// Which effects have at least one questionnaire response from this persona?
// fields = QuestionnaireFields docs (EffectId is an array of effect IDs),
// responses = QuestionnairesResponses docs for one persona.

export const indicatorsForEffect = (fields, effectId) =>
    (fields || []).filter(field => Array.isArray(field.EffectId) && field.EffectId.includes(effectId))

const effectsWithPersonaResults = (effects, fields, responses) => {
    const respondedFieldIds = new Set(
        (responses || []).map(response => response.FieldID).filter(Boolean)
    )

    return (effects || []).filter(effect =>
        indicatorsForEffect(fields, effect.ID).some(field => respondedFieldIds.has(field.ID))
    )
}

export default effectsWithPersonaResults
